export default __webpack_public_path__ + "static/media/marks.2780c578.svg";